import { register } from '../../../Javascript/Utils'

const component = el => {
  const clearLogin = el.querySelectorAll('a[data-clear-login]')

  if (clearLogin) {
    // console.log("clear login available")
    Array.from(clearLogin).forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault()
        // console.log("clicked")
        document.cookie = 'fe_patient=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        document.cookie = 'fe_hcp=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        /* eslint-disable */
        fetch('?logintype=logout')
          // .then(function() {
          //   console.log("logged out")
          // })
          .then(function(body) {
            window.location.href = event.target.closest('a').href
          })
         /* eslint-enable */
      })
    })
  }
}

register('LoginSwitch', component)
